import { Col, Form, Row } from 'antd';
import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import CustomButton from '../../../../v2-components/Antd/Button';
import CustomCard from '../../../../v2-components/Antd/Card';
import CustomDescriptions from '../../../../v2-components/Antd/Descriptions';
import CustomFormItem from '../../../../v2-components/Antd/FormItem';
import CustomInput from '../../../../v2-components/Antd/Input';
import CustomLink from '../../../../v2-components/Antd/Link';
import { CustomNotification } from '../../../../v2-components/Antd/Notification';
import LoadingModal from '../../../../v2-components/LoadingModal';
import { VALIDATION } from '../../../../v2-config/constants/validations.constant';
import { CLAIMS_DICTIONARY } from './constants/claims.dictionary';
import { DICTIONARY } from './constants/dictionary.constant';
import { Service } from './service';
import './style.scss';
import ScrollToTop from '../../../../v2-components/ScrollToTop';

export default function ClaimsSearchPage() {
	const [form] = Form.useForm();
	const [claim, setClaim] = useState();
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [isMobile, setMobile] = useState(false);

	const handleFinish = (item) => {
		setOpenLoadingModal(true);
		setIsLoadingModal(true);
		new Service()
			.getClaimByClaimId(item.claim_id)
			.then((response) => {
				console.log('response', response);
				if (response.data.length === 0) {
					setIsLoadingModal(false);
					setOpenLoadingModal(false);
					form.resetFields();
					setClaim(null);
					return CustomNotification({ type: 'error', message: 'Sin resultados', description: 'No se encontraron resultados' });
				}
				setClaim(response.data[0]);
				setIsLoadingModal(false);
				setOpenLoadingModal(false);
				form.resetFields();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	useEffect(() => {
		if (window.innerWidth < 768) setMobile(true);
	}, []);

	const scrollToFirstError = () => {
		if (!isMobile) return;
		const selector = '.ant-form-item-explain.ant-form-item-explain-error, .form-primary .ant-form-item-explain.ant-form-item-explain-error';
		const timeout = 1500;
		const interval = 100;
		const start = Date.now();
		const tryFind = () => {
			const errors = document.querySelectorAll(selector);
			if (errors && errors.length > 0) {
				const list = Array.from(errors).map((el) => ({ el, y: el.getBoundingClientRect().top + window.pageYOffset }));
				list.sort((a, b) => a.y - b.y);
				const first = list[0];
				try {
					if (first && first.el && first.el.scrollIntoView) {
						first.el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
					} else {
						const top = first.el.getBoundingClientRect().top + window.pageYOffset;
						const target = Math.max(top - window.innerHeight / 2 + (first.el.getBoundingClientRect().height || 0) / 2, 0);
						window.scrollTo({ top: target, behavior: 'smooth' });
					}
				} catch (e) {
					const top = first.el.getBoundingClientRect().top + window.pageYOffset;
					const target = Math.max(top - window.innerHeight / 2 + (first.el.getBoundingClientRect().height || 0) / 2, 0);
					window.scrollTo({ top: target, behavior: 'smooth' });
				}
				const input = first.el.closest('.ant-form-item')?.querySelector('input, textarea, select, .ant-select');
				if (input) {
					try {
						input.focus();
					} catch (e) {}
				}
				return;
			}
			if (Date.now() - start < timeout) setTimeout(tryFind, interval);
		};
		tryFind();
	};

	
	


	const items = [
		{
			key: 1,
			label: 'Fecha',
			children: moment.unix(claim?.created_at).format('DD/MM/YYYY hh:mm:ss A'),
		},
		{
			key: 2,
			label: 'Solicitud N°',
			children: claim?.claim_id,
		},

		{
			key: 3,
			label: 'Tipo de solicitud',
			children: CLAIMS_DICTIONARY[claim?.type],
		},

		{
			key: 4,
			label: 'Mensaje',
			children: claim?.message,
		},
		{
			key: 5,
			label: 'Respuesta',
			children: claim?.response || '--',
		},
		{
			key: 6,
			label: 'Estado',
			children: DICTIONARY[claim?.status],
		},
	];

	const searchResults = (claim) => {
		if (claim) {
			return (
				<CustomCard className={'card-primary'} title="Resultado de búsqueda">
					<CustomDescriptions title={'Información de la solicitud'} items={items} />
				</CustomCard>
			);
		}
		return null;
	};


	return (
		<>
			<ScrollToTop />
			<Row justify="center" className="search-content">
				<Col md={18} xs={22}>
					<Row justify="left">
						<CustomLink className={'link-primary'} to="/claims">
							Volver
						</CustomLink>
					</Row>
					<br></br>
					<CustomCard className={'card-primary'} title="Buscar una solicitud">
						<Form form={form} layout="vertical" onFinish={handleFinish} onFinishFailed={() => scrollToFirstError()}>
							<CustomFormItem className={'form-primary'} label={'Número de reclamo'} name={'claim_id'} rules={VALIDATION.number}>
								<CustomInput className={'input-primary'} />
							</CustomFormItem>

							<CustomButton className={'button-primary'} htmlType="submit">
								Buscar
							</CustomButton>
						</Form>
					</CustomCard>
					<br></br>
					{searchResults(claim)}
					<LoadingModal loading={isLoadingModal} visible={openLoadingModal} />
				</Col>
			</Row>
		</>
	);
}
